import { useAuth } from '@klear/ui/contexts/auth-context'
import { useNavigate } from 'react-router'
import { useEffect } from 'react'
import { ROUTE_RECEIVABLES, ROUTE_TRADER } from '@klear/constants'

const Dashboard = () => {
  const navigate = useNavigate()
  const { user } = useAuth()

  useEffect(() => {
    if (user.isCSM || user.isFunder) {
      navigate(`/${ROUTE_RECEIVABLES}`, { replace: true })
    } else {
      navigate(`/${ROUTE_TRADER}`, { replace: true })
    }
  }, [navigate, user.isCSM, user.isFunder])

  return null
}

export default Dashboard
